declare global {
    interface Window {
        dataLayer: any;
    }
}

class GTMService {

    static enabledShopId = [
        // valid
        '1002476',
        // prod     
        '1006243', '1006245', '1006247', '1006246', '1006244'        
    ]

    public static pushDataLayer(data: object) {
        if (window.dataLayer && data) {
            window.dataLayer.push(data);
        }
    }

    public static dataLayerProductDetail(product: MerchantCartItem, merchant: MerchantStore) {
        
        if(!GTMService.enabledShopId.find(s => s == merchant.shopId))
        {
            return;
        }
        
        GTMService.pushDataLayer({
            event: "productDetail",
            ecommerce: {
                detail: {
                    products: [
                        {
                            name: product.name,
                            id: product.id,
                            price: product.sellingPrice,
                            brand: merchant.shopName
                        },
                    ],
                },
            },
        })
    }

    public static dataLayerAddToCart(product: MerchantCartItem, merchant: MerchantStore, quantity: number) {

        if(!GTMService.enabledShopId.find(s => s == merchant.shopId))
        {
            return;
        }

        GTMService.pushDataLayer({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'EUR',
                'add': {
                    'products': [{
                        'name': product.parentProduct ? product.parentProduct.name : product.name,
                        'id': product.parentProduct ? product.parentProduct.id : product.id,
                        'price': product.sellingPrice,
                        'brand': merchant ? merchant.shopName : null,
                        'quantity': quantity,
                        'variant': product.parentProduct ? product.name : null,
                    }]
                }
            }
        })
    }

    public static dataLayerRemoveFromCart(product: MerchantCartItem, merchant: MerchantStore) {

        if(!GTMService.enabledShopId.find(s => s == merchant.shopId))
        {
            return;
        }

        GTMService.pushDataLayer({
            'event': 'removeFromChart',
            'ecommerce': {
                'currencyCode': 'EUR',
                'add': {
                    'products': [{
                        'name': product.parentProduct ? product.parentProduct.name : product.name,
                        'id': product.parentProduct ? product.parentProduct.id : product.id,
                        'price': product.sellingPrice,
                        'brand': merchant ? merchant.shopName : null,
                        'quantity': product.requestedQuantity,
                        'variant': product.parentProduct ? product.name : null,
                    }]
                }
            }
        })
    }

    public static dataLayerCheckoutStep1(cart: MerchantCart, merchant: MerchantStore) {

        if(!GTMService.enabledShopId.find(s => s == merchant.shopId))
        {
            return;
        }
        
        GTMService.pushDataLayer({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': 1
                    },
                    'products': cart.products.map(product => ({
                        'name': product.name,
                        'id': product.parentProduct ? product.parentProduct.id : product.id,
                        'price': product.sellingPrice,
                        'brand': merchant ? merchant.shopName : null,
                        'quantity': product.requestedQuantity,
                        'variant': 'variantName' in product ? product.variantName : null,
                    }))
                }
            }
        })
    }

    public static dataLayerCheckoutStep2(cart: MerchantCart, merchant: MerchantStore) {

        if(!GTMService.enabledShopId.find(s => s == merchant.shopId))
        {
            return;
        }
        
        GTMService.pushDataLayer({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': 2
                    },
                    'products': cart.products.map(product => ({
                        'name': product.name,
                        'id': product.parentProduct ? product.parentProduct.id : product.id,
                        'price': product.sellingPrice,
                        'brand': merchant ? merchant.shopName : null,
                        'quantity': product.requestedQuantity,
                        'variant': 'variantName' in product ? product.variantName : null,
                    }))
                }
            }
        })
    }   
    

    public static dataLayerPurchase(cart: MerchantCart, merchant: MerchantShopDetails, checkout: Checkout) {

        if(!GTMService.enabledShopId.find(s => s == (merchant.id as unknown)))
        {
            return;
        }
        GTMService.pushDataLayer({
            'event': 'purchase',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': checkout.id,
                        'revenue' : checkout.amount
                    },
                    'products': cart.products.map(product => ({
                        'name': product.parentProduct ? product.parentProduct.name : product.name,
                        'id': product.parentProduct ? product.parentProduct.id : product.id,
                        'price': product.sellingPrice,
                        'brand': merchant ? merchant.name : null,
                        'quantity': product.requestedQuantity,
                        'variant': product.parentProduct ? product.name : null,
                    }))
                }
            }
        })
    }      
}

export default GTMService